import { buildInteractiveResult, Result } from "@coveo/headless";
import React, {FunctionComponent, useEffect, useState, Fragment} from "react";
import { affiliatecontextTopResultsSuggestions, contextAffiliate, contextHeadlessSuggestions, contextProductFinderSuggestions, contextResourcesSuggestions, contextSupportSearchHero, contextTopResultsSuggestions } from "../../../controllers/contextControllers";
import { affiliateEngine, affiliateTopResultsEngine, headlessEngine, headlessEngineResourcesAutoSuggestions, headlessEngineTopResultsAutoSuggestions, productFinderEngine, supportSearchEngine } from "../../../engine/engine";
import { Section_Click } from "../../../utils/utils";

interface InteractiveResultProps {
  result: Result;
  sectionClick?: string;
  isAffiliate?: boolean;
  isCommunity?: boolean;
  product_use?: boolean;
  product_compatibility?: boolean;
  reviewRedirection?: string;
  price?: any;
  openNewTab?: boolean;
  videoId?: string;
  redirectPath?: string; // used in Product finder search box
  highlightedValue?: any; // used in Top Results in Global search
  spdp?: boolean; // used in Top Results in Global search
  classList?: string; // used in Top Results in Global search
  hasOosl?: boolean; // used for Product Support listing item
  compatibilityUrl?: any; // used for Compatibility CTA in Top Results in Global Search
}
export const InteractiveResult: FunctionComponent<InteractiveResultProps> = (
  props
) => {
  let engineValue = headlessEngine;
  if (props.isAffiliate) {
    engineValue = affiliateEngine;
    switch (props.sectionClick) {
      case Section_Click.SEARCH_RESULTS:
        engineValue = affiliateEngine;
        break;
      case Section_Click.TOP_RESULTS:
        engineValue = affiliateTopResultsEngine;
        break;
      default:
        break;
    }
  } else {
    engineValue = headlessEngine;
    switch (props.sectionClick) {
      case Section_Click.TOP_RESULTS:
        engineValue = headlessEngineTopResultsAutoSuggestions;
        break;
      case Section_Click.RESOURCES:
        engineValue = headlessEngineResourcesAutoSuggestions;
        break;
      case Section_Click.PRODUCT_FINDER:
        engineValue = productFinderEngine;
        break;
      case Section_Click.SUPPORT_SEARCH:
        engineValue = supportSearchEngine;
        break;
    }
  }
  const controller = buildInteractiveResult(engineValue, {
    options: { result: props.result },
  });
  const { openNewTab } = props;
  const [isClicked, setIsClicked] = useState(false);
  useEffect(() => () => controller.cancelPendingSelect());

  function clickHandler(e: any){
      if (isClicked) {
          return;
      }
      setIsClicked(true);
    try {
      if (props.isAffiliate) {
        addContext(contextAffiliate);
        if (props.sectionClick === Section_Click.TOP_RESULTS) {
          addContext(affiliatecontextTopResultsSuggestions);
        }
      } else {
        addContext(contextHeadlessSuggestions)
        switch (props.sectionClick) {
          case Section_Click.TOP_RESULTS:
            addContext(contextTopResultsSuggestions);
            break;
          case Section_Click.RESOURCES:
            addContext(contextResourcesSuggestions);
            break;
          case Section_Click.PRODUCT_FINDER:
            addContext(contextProductFinderSuggestions);
            break;
          case Section_Click.SUPPORT_SEARCH:
            addContext(contextSupportSearchHero);
            break;
        }
      }
      controller.select();
      }
      catch (exception_var) {
        console.log(exception_var)
      }
      setIsClicked(false);
      if(props.openNewTab && !props.highlightedValue) {
        window.open(hrefRedirection);
      } else {
          window.location.href = hrefRedirection;
      }
  };

  function addContext(context: any){
    const transformRaw: any = {
      ec_category:  props.result.raw['ec_category']? props.result.raw['ec_category'] : undefined,
      sfproductcategoryhierachy__c:  props.result.raw['sfproductcategoryhierachy__c'] ?  props.result.raw['sfproductcategoryhierachy__c'] : undefined,
      aem_producttype:  props.result.raw['aem_producttype']? props.result.raw['aem_producttype'] : undefined,
      aem_type:  props.result.raw['aem_type']? props.result.raw['aem_type'] : undefined,
      commonsupportcontenttype:  props.result.raw['commonsupportcontenttype']? props.result.raw['commonsupportcontenttype'] : undefined,
      aem_contenttype:  props.result.raw['aem_contenttype']? props.result.raw['aem_contenttype'] : undefined,
      price : props.price ? props.price : undefined,
    };

    // Remove the current value in context controller
    if (props.isAffiliate) {
      contextAffiliate.remove('name');
      contextAffiliate.remove('category');
      contextAffiliate.remove('price');
    } else {
      contextHeadlessSuggestions.remove('name');
      contextHeadlessSuggestions.remove('category');
      contextHeadlessSuggestions.remove('price');
    }

    context.add('name',props.result.title);
    context.add('price' , transformRaw.price);
    if(transformRaw.ec_category){
      context.add('category',transformRaw.ec_category) 
    }else if(transformRaw.sfproductcategoryhierachy__c){
      context.add('category',transformRaw.sfproductcategoryhierachy__c)
    }else if(transformRaw.aem_producttype){
      context.add('category',transformRaw.aem_producttype)
    }else if(transformRaw.aem_type){
      context.add('category',transformRaw.aem_type)
    }else if(transformRaw.commonsupportcontenttype){
      context.add('category',transformRaw.commonsupportcontenttype)
    }else if(transformRaw.aem_contenttype){
      context.add('category',transformRaw.aem_contenttype)
    }
  }

  const ooslValue : HTMLInputElement | null = document.querySelector("input[name=ooslPath]");
  let ooslPath = ooslValue?.value + `?prodName=${encodeURIComponent(props.result.title)}`;
  const isOosl = props.result.raw.retired_product && props.result.raw.retired_product === "Yes";
  let hrefRedirection: any = props.result.clickUri;
  if (props.isAffiliate) {
      if (props.product_compatibility) {
          let productUrl: any = props.result.raw.product_url || null;
          const textAfterShop = productUrl.match(/shop\/(.*)/)[1];
          const affStore = textAfterShop.split("/")[0];
          const productName = props.result.raw.url_key? props.result.raw.url_key : '';
          hrefRedirection = "/shop/" + affStore + "/view-all-accessories/" + productName;
      } else {
        hrefRedirection = props.reviewRedirection ? props.reviewRedirection : props.result.raw.product_url;
      }
} else {
    if (props.product_use) {
      hrefRedirection = props.reviewRedirection ? props.reviewRedirection : props.result.raw.product_url ? props.result.raw.product_url : props.result.raw.spdp_url;
    } else if (props.videoId || props.videoId === "") {
      if (props.videoId !== "" && props.videoId !== "no video found") {
        hrefRedirection = "https://www.youtube.com/watch?v=" + props.videoId;
      } else {
        hrefRedirection = "#";
      }
    } else if (props.redirectPath) {
      hrefRedirection = props.redirectPath;
    } else if (props.spdp) {
      hrefRedirection = props.result.raw.spdp_url;
    } else if (props.product_compatibility) {
      hrefRedirection = props.compatibilityUrl;
    } else if (props.result?.raw?.source?.includes("Salesforce")) {
      let publicUrl: any = props.result.raw.sfpublicurl__c;
      hrefRedirection = !publicUrl ? "" : "https://" + publicUrl.replace("https://", "").replace("http://", "");
    }
  }

  if (props.highlightedValue) {
    return (
      <a
        onClick={clickHandler}
        onMouseDown={clickHandler}
        onMouseUp={clickHandler}
        onTouchStart={() => controller.beginDelayedSelect()}
        onTouchEnd={() => controller.cancelPendingSelect()}
        dangerouslySetInnerHTML={{
          __html: props.highlightedValue,
        }}
      ></a>
    );
  }

  return (
      <Fragment>
          {
              openNewTab && (
                  <a
                      onClick={clickHandler}
                      onTouchStart={() => controller.beginDelayedSelect()}
                      onTouchEnd={() => controller.cancelPendingSelect()}
                      target={"_blank"}
                      className={props.classList ? props.classList : ""}
                  >
                      {props.children}
                  </a>
              )
          }
          {
              !openNewTab && (
              <a
              onClick={clickHandler}
              onMouseDown={clickHandler}
              onMouseUp={clickHandler}
              onTouchStart={() => controller.beginDelayedSelect()}
              onTouchEnd={() => controller.cancelPendingSelect()}
              target={"_self"}
              className={props.classList ? props.classList : ""}
              >
              {props.children}
              </a>
              )
          }

      </Fragment>

  );
};
